import { Component } from '@angular/core';

@Component({
  selector: 'app-short-link-management',
  templateUrl: './short-link-management.component.html',
  styleUrls: ['./short-link-management.component.scss']
})
export class ShortLinkManagementComponent {

}
